import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

export type MaskShapeVariant = "four_vertical_even" | "two_vertical_uneven" | "wave" | "split_half_circle" | "three_horizontal_even" | "three_vertical_uneven" | "three_vertical_uneven_mirrored" | "circle";

type MaskShapeProps = {
  variant?: MaskShapeVariant;
} & ComponentProps<"svg">;

const Shape01 = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M145.324 200C145.324 310.457 112.792 400 72.6619 400C32.5318 400 0 310.457 0 200C0 89.543 32.5318 0 72.6619 0C112.792 0 145.324 89.543 145.324 200Z"
      fill="currentColor"
    />
    <path
      d="M230.216 200C230.216 310.457 197.684 400 157.554 400C117.424 400 84.8921 310.457 84.8921 200C84.8921 89.543 117.424 0 157.554 0C197.684 0 230.216 89.543 230.216 200Z"
      fill="currentColor"
    />
    <path
      d="M315.108 200C315.108 310.457 282.576 400 242.446 400C202.316 400 169.784 310.457 169.784 200C169.784 89.543 202.316 0 242.446 0C282.576 0 315.108 89.543 315.108 200Z"
      fill="currentColor"
    />
    <path
      d="M400 200C400 310.457 367.468 400 327.338 400C287.208 400 254.676 310.457 254.676 200C254.676 89.543 287.208 0 327.338 0C367.468 0 400 89.543 400 200Z"
      fill="currentColor"
    />
  </svg>
);

const Shape02 = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M160 200C160 310.457 124.183 400 80 400C35.8172 400 0 310.457 0 200C0 89.5431 35.8172 0 80 0C124.183 0 160 89.5431 160 200Z"
      fill="currentColor"
    />
    <path
      d="M400 200C400 310.457 335.081 400 255 400C174.919 400 110 310.457 110 200C110 89.5431 174.919 0 255 0C335.081 0 400 89.5431 400 200Z"
      fill="currentColor"
    />
  </svg>
);

const Shape03 = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M167.442 200C167.442 89.54 200.763 0 241.86 0C282.958 0 316.279 89.54 316.279 200H167.442Z"
      fill="currentColor"
    />
    <path
      d="M0 200C0 89.54 33.3209 0 74.4186 0C115.516 0 148.837 89.54 148.837 200H0Z"
      fill="currentColor"
    />
    <path
      d="M400 200C400 310.46 366.679 400 325.581 400C284.484 400 251.163 310.46 251.163 200H400Z"
      fill="currentColor"
    />
    <path
      d="M232.558 200C232.558 310.46 199.237 400 158.14 400C117.042 400 83.7209 310.46 83.7209 200H232.558Z"
      fill="currentColor"
    />
  </svg>
);

const Shape04 = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 400C110.717 400 200.471 310.457 200.471 200C200.471 89.5431 110.717 0 0 0V400Z"
      fill="currentColor"
    />
    <path
      d="M200.471 400C310.668 400 400 310.457 400 200C400 89.5431 310.668 0 200.471 0V400Z"
      fill="currentColor"
    />
  </svg>
);

const Shape05 = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M400 90C400 139.706 310.457 180 200 180C89.543 180 0 139.706 0 90C0 40.2944 89.543 0 200 0C310.457 0 400 40.2944 400 90Z"
      fill="currentColor"
    />
    <path
      d="M400 200C400 249.706 310.457 290 200 290C89.543 290 0 249.706 0 200C0 150.294 89.543 110 200 110C310.457 110 400 150.294 400 200Z"
      fill="currentColor"
    />
    <path
      d="M400 310C400 359.706 310.457 400 200 400C89.543 400 0 359.706 0 310C0 260.294 89.543 220 200 220C310.457 220 400 260.294 400 310Z"
      fill="currentColor"
    />
  </svg>
);

const Shape06 = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M160 200C160 310.457 124.183 400 80 400C35.8172 400 0 310.457 0 200C0 89.5431 35.8172 0 80 0C124.183 0 160 89.5431 160 200Z"
      fill="currentColor"
    />
    <path
      d="M240 200C240 310.457 204.183 400 160 400C115.817 400 80 310.457 80 200C80 89.5431 115.817 0 160 0C204.183 0 240 89.5431 240 200Z"
      fill="currentColor"
    />
    <path
      d="M400 200C400 310.457 347.617 400 283 400C218.383 400 166 310.457 166 200C166 89.5431 218.383 0 283 0C347.617 0 400 89.5431 400 200Z"
      fill="currentColor"
    />
  </svg>
);

const Shape08 = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M400 200C400 310.5 364.2 400 320 400C275.8 400 240 310.5 240 200C240 89.5 275.8 0 320 0C364.2 0 400 89.5 400 200Z"
      fill="currentColor"
    />
    <path
      d="M314 200C314 310.5 278.2 400 234 400C189.8 400 154 310.5 154 200C154 89.5 189.8 0 234 0C278.2 0 314 89.5 314 200Z"
      fill="currentColor"
    />
    <path
      d="M234 200C234 310.5 181.6 400 117 400C52.4 400 0 310.5 0 200C0 89.5 52.4 0 117 0C181.6 0 234 89.5 234 200Z"
      fill="currentColor"
    />
  </svg>
);

const Shape07 = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="200" cy="200" r="200" fill="currentColor" />
  </svg>
);

const MaskShape = ({ variant = "four_vertical_even", className, ...props }: MaskShapeProps) => {
  const sharedClassName = cn("text-gray-50", className);

  switch (variant) {
    case "four_vertical_even":
      return <Shape01 className={sharedClassName} {...props} />;
    case "two_vertical_uneven":
      return <Shape02 className={sharedClassName} {...props} />;
    case "wave":
      return <Shape03 className={sharedClassName} {...props} />;
    case "split_half_circle":
      return <Shape04 className={sharedClassName} {...props} />;
    case "three_horizontal_even":
      return <Shape05 className={sharedClassName} {...props} />;
    case "three_vertical_uneven":
      return <Shape06 className={sharedClassName} {...props} />;
    case "three_vertical_uneven_mirrored":
      return <Shape08 className={sharedClassName} {...props} />;
    case "circle":
      return <Shape07 className={sharedClassName} {...props} />;
    default:
      return <Shape01 className={sharedClassName} {...props} />;
  }
};

export { MaskShape };
